<script setup lang="ts">
import Tag from "~/components/Common/Tag.vue";
import AppButton from "~/components/Common/Buttons/AppButton.vue";
import { ColorsTypeEnum } from "~/utils/enums/colores.enums";
import { SessionDetailsTabNamesEnum } from "~/utils/enums/session-details-enums";

// Replaces the legacy "Satisfaction du participant à chaud" / "Satisfaction du manager à froid" blocks
// (Typeform-era, deleted with this change): satisfaction results now live in the session's Enquêtes
// tab, so the inscription panel only points at them. Figma 1090-698 / US-IMPACT-01.
//
// Container styling mirrors the sibling sections (SessionRecap): pt + bottom hairline, grey inner card.
//
// `sessionId` comes from the parent rather than a store lookup: this panel serves BOTH session- and
// project-backed inscriptions, and only the parent's useSessionIndividual knows which (a project has no
// session, so no Enquêtes tab to link to). sessionDetailsStore is not populated on /registrations.
const props = defineProps<{ sessionId?: string | null }>();

function openSurveys() {
  if (!props.sessionId) return;
  // The tab is passed as a query param, not via the store's `tabPreSelected`: this opens a NEW browser
  // tab, so store state wouldn't survive. SessionDetailsTabContainer reads `tab` on mount.
  const tab = encodeURIComponent(SessionDetailsTabNamesEnum.SURVEYS);
  window.open(`/sessions?id=${props.sessionId}&type=session&tab=${tab}`, "_blank", "noopener,noreferrer");
}
</script>

<template>
  <div class="pt-2 border-b border-stroke-color">
    <div class="flex items-center gap-2 p-2">
      <h3 class="heading_3_demi text-primary-color">Enquêtes de satisfaction</h3>
      <Tag :tag="{ value: 'NEW', type: ColorsTypeEnum.LIGHT_BLUE }" />
    </div>

    <div class="flex flex-col items-start gap-2 mx-2 mt-2 mb-8 p-4 rounded-lg bg-lightest-grey-color">
      <p class="body_regular text-secondary-color">
        Les enquêtes de satisfaction ont été déplacées. Retrouvez l'ensemble des résultats dans l'onglet
        {{ SessionDetailsTabNamesEnum.SURVEYS }}.
      </p>
      <!-- Hidden rather than disabled when there's no session to point at (e.g. an individual inscription
           with no parent session): a dead link is worse than no link. -->
      <AppButton
        v-if="sessionId"
        type="link"
        icon="link"
        :label="`Aller à l'onglet ${SessionDetailsTabNamesEnum.SURVEYS}`"
        @click="openSurveys"
      />
    </div>
  </div>
</template>
